import { render } from "./CreditNotificationsPanel.vue?vue&type=template&id=91da7142&scoped=true"
import script from "./CreditNotificationsPanel.vue?vue&type=script&lang=js"
export * from "./CreditNotificationsPanel.vue?vue&type=script&lang=js"

import "./CreditNotificationsPanel.vue?vue&type=style&index=0&id=91da7142&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-91da7142"]])

export default __exports__